import { FormFieldTypes } from '../../../models';

export const fieldTypeMapper = (type: FormFieldTypes) => {
  switch (type) {
    case FormFieldTypes.text:
      return 'Text';
    case FormFieldTypes.date:
      return 'Date';
    case FormFieldTypes.multipleSelection:
      return 'Multiple Selection';
    case FormFieldTypes.longText:
      return 'Long Text';
    case FormFieldTypes.number:
      return 'Number';
    case FormFieldTypes.singleSelection:
      return 'Single Selection';
    case FormFieldTypes.separator:
      return 'Separator';
    case FormFieldTypes.signature:
      return 'Signature';
  }
};
